import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useMemo } from "react";
import styled, { css } from "styled-components";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import useSuggestionsMenu from "./useSuggestionsMenu";
const MentionsMenuWrapper = styled(Box)`
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`;
const MentionWrapper = styled(Flex)`
  cursor: pointer;
  user-select: none;

  ${media.up("medium", "pointer")} {
    :hover {
      background: ${themeGet("colors.black.12")};
    }
  }

  :active {
    background: ${themeGet("colors.black.16")};
  }

  ${({ $selected  })=>$selected && css`
      background: ${themeGet("colors.black.12")};
    `}
`;
const MentionsMenu = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { items , command  } = props;
    const itemsCount = items.length;
    const onEnter = useCallback((index)=>{
        const item = items[index];
        command(item);
    }, [
        command,
        items
    ]);
    const { selectedIndex  } = useSuggestionsMenu(useMemo(()=>{
        return {
            itemsCount,
            onEnter,
            ref
        };
    }, [
        itemsCount,
        onEnter,
        ref
    ]));
    if (items.length === 0) return null;
    return /*#__PURE__*/ _jsx(MentionsMenuWrapper, {
        p: 1,
        color: "white.100",
        bg: "blue.500",
        borderRadius: "12px",
        overflow: "hidden",
        as: "ul",
        children: items.map((item, index)=>{
            const { username , fullName  } = item;
            return /*#__PURE__*/ _jsxs(MentionWrapper, {
                borderRadius: "12px",
                alignItems: "center",
                height: "48px",
                px: 1,
                as: "li",
                $selected: selectedIndex === index,
                onClick: ()=>{
                    onEnter(index);
                },
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        fontSize: "15px",
                        fontWeight: "bold",
                        mr: 1,
                        children: username
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        truncate: true,
                        fontSize: "15px",
                        fontWeight: "medium",
                        children: fullName
                    })
                ]
            }, username);
        })
    });
});
export default MentionsMenu;
